/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState,useContext } from "react";
import { XIcon } from "@heroicons/react/solid";
import { openDB } from "idb";
import { useParams } from "react-router-dom";
import { v4 as uuid } from "uuid";
import Context from "../context/context"
export default function NewCategory({
  close,
  type,
  id,
  setAllCategories,
  AllCategories,
}) {
  const { bId } = useParams();
  const [editCat, setEditCat] = useState({});
  const [categoryName, setCategoryName] = useState("");
  const [dbMenu, setDbMenu] = useState({});
 const context = useContext(Context);
 const { updateUnSync } = context;

  //Fetching all the existing menus and categories form indexDB
  useEffect(() => {
    const handle = async () => {
      const db = await openDB(
        "FoodDo",
        +localStorage.getItem("IDBVersion") || 1
      );
      const tx2 = await db
        .transaction("menu", "readwrite")
        .objectStore("menu")
        .getAll();
      await setDbMenu(tx2.filter((a) => a.brand_uuid === bId));

      if (type !== "New") {
        const tx = await db
          .transaction("category", "readwrite")
          .objectStore("category")
          .getAll();
        await setEditCat(tx.filter((item) => item.category_uuid === id)[0]);
        setCategoryName(
          tx.filter((item) => item.category_uuid === id)[0].category_name
        );
      }
    };
    handle();
  }, [type, id]);

  // Adding new category to category collection in IndexedDB
  const handleNewCategory = async () => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("category", "readwrite")
      .objectStore("category");
    const id = uuid();
    const data = {
      IDENTIFIER: id,
      brand_uuid: bId,
      category_name: categoryName,
      category_uuid: id,
      outlet_uuid: [localStorage.getItem("outlet_uuid")],
    };
    setAllCategories([...AllCategories, data]);
    await tx.add(data);
    await handleMenuEdit(data);
    await handleNewCatUnsyncedFile(data);
    close();
  };

  // Editing existing category in category collection in IndexedDB
  const handleCategoryEdit = async () => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("category", "readwrite")
      .objectStore("category");
    const data = {
      ...editCat,
      category_name: categoryName,
    };
    await tx.put(data);
    setAllCategories(
      AllCategories.map((a) => {
        if (a.category_uuid === id) {
          return data;
        } else return a;
      })
    );
    handleCategoryEditUnsyncedFile(data);
    close();
  };

  // Adding new category to menu collection in IndexedDB
  const handleMenuEdit = async (catData) => {
    console.log(catData.category_uuid);
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = db.transaction("menu", "readwrite").objectStore("menu");
    const currentMenues = await tx.getAll();
    let allMenus = dbMenu;
    let x = currentMenues
      .filter((menuWithSameBrandId) => menuWithSameBrandId.brand_uuid === bId)
      .map((menu) => {
        console.log(menu.menu_uuid);
        const lastIndex = menu.category_and_items.length - 1;
        const sortOrder =
          parseInt(
            menu.category_and_items[lastIndex]?.menu_category_sort_order
          ) + 1;
        allMenus = {
          ...menu,
          category_and_items: [
            ...menu.category_and_items,
            {
              category_uuid: catData.category_uuid,
              menu_category_sort_order: String(sortOrder),
              menu_items: [],
            },
          ],
        };
        return allMenus;
      });

    let z = window.location.pathname.split("/").filter((i) => i !== "");
    await x.map(async (entry) => {
      if (entry.menu_uuid === z[2])
        console.log(
          entry.category_and_items.filter(
            (i) => i.category_uuid === catData.category_uuid
          )
        );

      await tx.put(entry);
      await handleMenuUnsyncedFile(entry);
    });
  };

  // Adding new added category to unsynced_files collection in IndexedDB
  const handleNewCatUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    const ndata = {
      ...data,
      RECON_TIME: Date.now(),
      IDENTIFIER: "category-new:" + data.category_uuid,
    };
    await tx.add(ndata);
    handleCategoryReconciliation(ndata);
    updateUnSync();
  };

  // Editing category in unsynced_files collection in IndexedDB
  const handleCategoryEditUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    const ndata = {
      ...data,
      RECON_TIME: Date.now(),
      IDENTIFIER: "category-edit:" + data.category_uuid,
    };
    await tx.put(ndata);
    handleCategoryReconciliation(ndata);
    updateUnSync()
  };

  // Adding/Editing new category added to menu in unsynced_files collection in IndexedDB
  const handleMenuUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    const allUnsyncedFiles = await tx.getAll();
    const ndata = {
      ...data,
      RECON_TIME: Date.now(),
      IDENTIFIER: "menu-edit:" + data.menu_uuid,
    };
    let currentUnsyncedFile = allUnsyncedFiles.find(
      (curr) => curr.IDENTIFIER === "menu-edit:" + data.menu_uuid
    );
    currentUnsyncedFile ? await tx.put(ndata) : await tx.add(ndata);
    handleMenuReconciliation(ndata);
    updateUnSync()
  };

  // Adding/Editing category to reconciliation collection in IndexedDB
  const handleCategoryReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const categoriesJsonExists = allReconRecords.find(
      (curr) => curr.IDENTIFIER === "category"
    );
    if (categoriesJsonExists) {
      const categories = categoriesJsonExists?.details?.filter(
        (category) => category.category_uuid !== data.category_uuid
      );
      const editData = {
        ...categoriesJsonExists,
        details: [
          ...categories,
          {
            category_uuid: data.category_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "category",
        details: [
          {
            category_uuid: data.category_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.add(newdata);
    }
  };

  // Adding/Editing menu to reconciliation collection in IndexedDB
  const handleMenuReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const menusJsonExists = allReconRecords.find(
      (curr) => curr.IDENTIFIER === "menu"
    );
    if (menusJsonExists) {
      const menus = menusJsonExists?.details?.filter(
        (menu) => menu.menu_uuid !== data.menu_uuid
      );
      const editData = {
        ...menusJsonExists,
        details: [
          ...menus,
          {
            menu_uuid: data.menu_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "menu",
        details: [
          {
            menu_uuid: data.menu_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.add(newdata);
    }
  };

  return (
    <div
      className='newCategory'
      onKeyDown={(e) =>
        e.key === "Enter" && categoryName !== ""
          ? type === "New"
            ? handleNewCategory()
            : handleCategoryEdit()
          : document.getElementById("catname").focus()
      }>
      <div className='newCatContainer'>
        <div className='newCatContainer_header'>
          <h2>Item Category</h2>
          <XIcon className='closeicon' onClick={close} />
        </div>
        <div className='newCatContainer2'>
          <div className='cat-inp'>
            <label htmlFor='catname'>Category Name</label>
            <input
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              maxLength={42}
              type='text'
              id='catname'
            />
          </div>
          {type === "New" ? (
            <button onClick={categoryName !== "" ? handleNewCategory : ""}>
              Save
            </button>
          ) : (
            <button onClick={categoryName !== "" ? handleCategoryEdit : ""}>
              Update
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
